import React from 'react';
import { StickyHeader } from '../components/sections/StickyHeader';
import { Hero } from '../components/sections/Hero';
import { SocialProof } from '../components/sections/SocialProof';
import { PainSection } from '../components/sections/PainSection';
import { ProductReveal } from '../components/sections/ProductReveal';
import { Tomos } from '../components/sections/Tomos';
import { Bonuses } from '../components/sections/Bonuses';
import { Urgency } from '../components/sections/Urgency';
import { Pricing } from '../components/sections/Pricing';
import { InnerCircle } from '../components/sections/InnerCircle';
import { Testimonials } from '../components/sections/Testimonials';
import { Guarantee } from '../components/sections/Guarantee';
import { FAQ } from '../components/sections/FAQ';
import { CostOfInaction } from '../components/sections/CostOfInaction';
import { FinalCTA } from '../components/sections/FinalCTA';
import { Footer } from '../components/sections/Footer';
import { useScreenInit } from '../useScreenInit';
export function LandingPage() {
  useScreenInit();
  return <div className="min-h-screen bg-[#0a0e1a] text-slate-200 font-sans selection:bg-amber-500/30 selection:text-amber-200" data-id="element-341">
      <StickyHeader data-id="element-342" />
      <main data-id="element-343">
        <Hero data-id="element-344" />
        <SocialProof data-id="element-345" />
        <PainSection data-id="element-346" />
        <ProductReveal data-id="element-347" />
        <Tomos data-id="element-348" />
        <Bonuses data-id="element-349" />
        <Urgency data-id="element-350" />
        <Pricing data-id="element-351" />
        <InnerCircle data-id="element-352" />
        <Testimonials data-id="element-353" />
        <Guarantee data-id="element-354" />
        <FAQ data-id="element-355" />
        <CostOfInaction data-id="element-356" />
        <FinalCTA data-id="element-357" />
      </main>
      <Footer data-id="element-358" />
    </div>;
}